<template>
  <div class="">
    <div
      v-if="recipientUpdate"
      class="notification is-warning is-padding-small is-marginless is-flex is-vcentered is-minH50p">
      <div class="is-self-centered has-text-centered w100 is-uppercase is-size-7">
        <span class="is-margin-right-xsmall">
          <span class="icon has-text-danger"><i class="fas fa-exclamation-triangle"></i></span>
        </span>
        <b class="has-text-weight-medium">
          Vérification de l’identité acquéreur requise par l’administrateur AR24
        </b>
      </div>
    </div>
    <div class="columns is-gapless is-padding-top is-padding-bottom-xlarge is-centered">
      <div class="column is-narrow is-size-5 is-size-6-widescreen is-size-4-fullhd">
        <i class="fal fa-5x fa-mail-bulk"></i>
      </div>
      <div class="column is-8 is-margin-left-large is-padding-top-xxsmall">
        <div class="title is-3 is-marginless  has-text-weight-medium">
          Courrier recommandé éléctronique (LRE)
        </div>
        <div><span class="is-size-7 has-text-success is-uppercase has-text-weight-medium">procédure LANCÉE LE {{ lre.created_on | date }}</span></div>
        <div class="columns is-padding-top-small">
          <div class="column is-padding-top-xsmall is-padding-left-xsmall">
            <ul class="steps is-xsmall steps--vertical-vad steps--separatorColorClassic-Vad">
              <li
                class="step-item"
                :class="sending ? 'is-success is-completed is-active' : ''"
                data-step-id="0">
                <div class="step-marker">
                  <span class="icon"><i class="fa fa-check"></i></span>
                </div>
                <div class="step-details">
                  <span
                    class="has-text-weight-medium is-uppercase"
                    :class="sending ? '' : 'has-text-grey-light'">
                    En cours d’envoi
                  </span>
                </div>
              </li>
              <li
                class="step-item"
                :class="sent ? 'is-success is-completed is-active' : ''"
                data-step-id="0">
                <div class="step-marker">
                  <span class="icon"><i class="fa fa-check"></i></span>
                </div>
                <div class="step-details">
                  <span
                    class="has-text-weight-medium is-uppercase"
                    :class="sent ? '' : 'has-text-grey-light'">
                    Envoyé
                    <a
                      v-if="proof_ev || (proof && !ar)"
                      :href="proof && !ar ? proof : proof_ev"
                      download
                      class="is-underline">(preuve d'envoi)</a>
                  </span>
                </div>
              </li>
              <li
                class="step-item"
                :class="receptionClass"
                data-step-id="0">
                <div class="step-marker">
                  <span
                    v-if="refused || bounced || negligence"
                    class="icon"><i class="fa fa-exclamation"></i></span>
                  <span
                    v-else
                    class="icon"><i class="fa fa-check"></i></span>
                </div>
                <div class="step-details">
                  <div class="has-text-weight-medium is-uppercase">
                    <span v-if="refused">
                      Refusée par le destinataire : le contrat à été refusé par le destinataire<a
                        v-if="proof"
                        class="is-underline">(preuve de refus)</a>
                    </span>
                    <span v-else-if="bounced">
                      Erreur lors de la Réception du lre : L'adresse email renvoie une erreur.
                    </span>
                    <span v-else-if="negligence">
                      Erreur de négligence : le destinataire n'a effectué aucune action (acceptée ou refusée)
                    </span>
                    <span
                      v-else
                      :class="ar ? '' : 'has-text-grey-light'">
                      Réceptionné <a
                        v-if="proof && ar"
                        :href="proof"
                        download
                        class="is-underline">(preuve de réception)</a>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="column">
          <button
            @click="changeModal"
            class="button is-small is-transform-none is-danger is-full">
            <span class="is-uppercase">relancer PROCÉDURE</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DematSru',
  props: {
    lre: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    /**
      * lre is sending
      * @returns {boolean}
      */
    sending () {
      if (this.lre) {
        return this.lre.status === 'waiting' || this.sent || this.recipientUpdate
      } else return false
    },
    /**
      * lre is sent
      * @returns {boolean}
      */
    sent () {
      if (this.lre) {
        return this.dp || this.ev || this.ar || this.refused || this.bounced || this.negligence || this.recipientUpdate
      } else return false
    },
    /**
      * lre status is refused
      * @returns {boolean}
      */
    refused () {
      return this.lre.status === 'refused'
    },
    /**
      * lre status is bounced
      * @returns {boolean}
      */
    bounced () {
      return this.lre.status === 'bounced'
    },
    negligence () {
      return this.lre.status === 'negligence'
    },
    /**
      * lre status is ar
      * @returns {boolean}
      */
    ar () {
      return this.lre.status === 'ar'
    },
    /**
      * lre status is dp
      * @returns {boolean}
      */
    dp () {
      return this.lre.status === 'dp'
    },
    /**
      * lre status is ev
      * @returns {boolean}
      */
    ev () {
      return this.lre.status === 'ev'
    },
    /**
      * lre status is recipient update
      * @returns {boolean}
      */
    recipientUpdate () {
      return this.lre.status === 'recipient_update'
    },
    /**
      * reception class
      * @returns {string}
      */
    receptionClass () {
      if (this.refused || this.bounced || this.negligence) {
        return 'is-danger is-completed is-active'
      } else if (this.ar) {
        return 'is-success is-completed is-active'
      } else {
        return ''
      }
    },
    /**
      * lre proof
      * @returns {string} - link
      */
    proof () {
      return this.lre.proof
    },
    proof_ev () {
      return this.lre.proof_ev
    }
  },
  methods: {
    /**
      * emit change modal
      */
    changeModal () {
      this.$emit('changeModal', 'registered')
    }
  }
}
</script>
